import styled from "styled-components";
import { TextField, Typography } from "@mui/material";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import { theme } from "../../utils/globalStyles/colors";
import {
  fadeIn,
  pressable,
  staggeredFadeInUp,
} from "../../utils/globalStyles/animations";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-sizing: border-box;
`;

export const FilterInput = styled(TextField)`
  width: 100%;

  & .MuiInputBase-root {
    background-color: #ffffff;
    border-radius: 12px;
  }

  & input {
    font-size: 16px; /* >= 16px evita o zoom automático do iOS ao focar */
    padding: 12px 4px;
  }

  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${theme.colors.base};
  }
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ContactCard = styled.div<{ $index: number }>`
  width: 100%;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 12px 12px 12px 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  outline: none;
  ${({ $index }) => staggeredFadeInUp($index)}
  ${pressable}

  &:focus-visible {
    border-color: ${theme.colors.base};
  }
`;

export const InfoGroup = styled.div`
  flex: 1;
  min-width: 0; /* permite cortar nomes longos com reticências */
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const Name = styled(Typography)`
  font-weight: 700 !important;
  color: #333333;
  font-size: 15px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SubInfo = styled(Typography)`
  color: #888888;
  font-size: 12px !important;
  font-weight: 600 !important;
`;

export const SendButton = styled.button`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0 14px;
  border: none;
  border-radius: 10px;
  background-color: ${theme.colors.base};
  color: #ffffff;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.15s ease;

  &:active {
    transform: scale(0.95);
  }
`;

export const SendIcon = styled(SendRoundedIcon)`
  font-size: 18px !important;
`;

export const Hint = styled(Typography)`
  color: #aaaaaa;
  font-size: 12px !important;
  text-align: center;
  padding: 4px 0 8px;
`;

export const NoResults = styled(Typography)`
  color: #999999;
  font-size: 14px !important;
  text-align: center;
  padding: 24px 8px;
  animation: ${fadeIn} 0.3s ease-out both;
`;

/* Lista vazia */
export const Empty = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 32px 16px;
  text-align: center;
  animation: ${fadeIn} 0.3s ease-out both;
`;

export const EmptyIcon = styled(PeopleOutlineIcon)`
  color: #d0d0d0;
  font-size: 56px !important;
`;

export const EmptyTitle = styled(Typography)`
  color: #555555;
  font-size: 16px !important;
  font-weight: 700 !important;
`;

export const EmptyText = styled(Typography)`
  color: #999999;
  font-size: 14px !important;
  max-width: 300px;
`;

export const PrimaryButton = styled.button`
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 48px;
  padding: 0 24px;
  border: none;
  border-radius: 12px;
  background-color: ${theme.colors.base};
  color: #ffffff;
  font-family: inherit;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(192, 90, 33, 0.25);
  transition: transform 0.15s ease;

  &:active {
    transform: scale(0.97);
  }
`;

export const AddIcon = styled(PersonAddIcon)`
  font-size: 20px !important;
`;

/* Esqueleto enquanto os dados do usuário carregam */
export const SkeletonCard = styled.div`
  width: 100%;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 12px 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-sizing: border-box;
  border: 1px solid rgba(0, 0, 0, 0.05);
`;

export const SkeletonText = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
